var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaVermoegen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#49bbee;}.cls-3{fill:#fec000;}.cls-4{fill:#7fc8f1;}.cls-5{fill:#a3d9f6;}.cls-6{fill:#cae8f9;}.cls-7{fill:#ffdf47;}.cls-8{fill:#ffcf00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.42,23.16a2.52,2.52,0,0,1-2.52-2.53V10.53a2.53,2.53,0,1,1,5,0v10.1a2.53,2.53,0,0,1-2.53,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.16,25.68A2.53,2.53,0,0,1,90,21.89L95,13.14a2.52,2.52,0,0,1,4.37,2.53l-5.05,8.75a2.51,2.51,0,0,1-2.19,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.48,109.05a2.52,2.52,0,0,1-2.53-2.52V96.42a2.53,2.53,0,1,1,5,0v10.11a2.52,2.52,0,0,1-2.52,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.11,111.58a2.53,2.53,0,0,1-2.19-3.79L138,99a2.53,2.53,0,0,1,4.38,2.52l-5,8.76a2.53,2.53,0,0,1-2.19,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.69,25.68a2.5,2.5,0,0,1-2.19-1.26l-5.06-8.75a2.53,2.53,0,0,1,4.38-2.53l5,8.75a2.53,2.53,0,0,1-2.18,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.21,66.11H8.79L29,40.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.42,40.84,49.21,66.11,29,40.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.84,40.84,89.63,66.11,69.42,40.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.06,66.11H89.63l20.21-25.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.06,66.11,69.42,152,89.63,66.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.42,152,8.79,66.11H49.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.63,66.11,69.42,152,49.21,66.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.63,66.11H49.21L69.42,40.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.11,136.84H104.79l5-15.16h20.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M120,152H89.63l5.06-15.16H114.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M150.27,152H120l5-15.16h20.21Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaVermoegen);
export default __webpack_public_path__ + "static/media/ka_vermoegen.a9841a2a6d046e6e92a3c865c4bedb3b.svg";
export { ForwardRef as ReactComponent };